import { valueOrNull } from '@utils';

import { resourceWithPagination } from './utils';

const RESOURCE_NAME = 'pages';

const createHandler = (schema, request) => {
  const { parentPageId, competitionId, eventId, typeId, ...attrs } = JSON.parse(request.requestBody);

  // TODO: differentiate draft from publish
  return schema.pages.create({
    ...attrs,
    type: valueOrNull(typeId && schema.pageTypes.find(typeId)),
    parentPage: valueOrNull(parentPageId && schema.pages.find(parentPageId)),
    competition: valueOrNull(competitionId && schema.competitions.find(competitionId)),
    event: valueOrNull(eventId && schema.events.find(eventId)),
    createdBy: schema.users.first(),
    publishedBy: schema.users.create(),
    modified: new Date().toISOString(),
    published: new Date().toISOString(),
  });
};

function updateHandler(schema, request) {
  const { id } = request.params;
  const attrs = JSON.parse(request.requestBody);

  // TODO: remove competition and event relation if page is not competition landing type
  // TODO: differentiate draft from publish

  return schema.pages.find(id).update(attrs);
}

export default function pagesRoutes(context) {
  resourceWithPagination(context, {
    resource: RESOURCE_NAME,
    paginatedSerializer: 'paginated-pages',
    except: ['create', 'update'],
  });

  context.post(`${RESOURCE_NAME}`, createHandler);
  context.put(`${RESOURCE_NAME}/:id`, updateHandler);

  context.get('/page-types');
}
